import * as THREE from "three";
import React, { useRef } from "react";
import { useLoader } from "react-three-fiber";
import { GLTFLoader, GLTF } from "three/examples/jsm/loaders/GLTFLoader";
type GLTFResult = GLTF & {
  nodes: {
    Main: THREE.Mesh;
    Glass: THREE.Mesh;
    Parking: THREE.Mesh;
    Rejas: THREE.Mesh;
    Torre_logo: THREE.Mesh;
    Main_screen: THREE.Mesh;
    Metal: THREE.Mesh;
    Grass: THREE.Mesh;
    Floor: THREE.Mesh;
    Herringbone: THREE.Mesh;
    Brick: THREE.Mesh;
    Sky_2: THREE.Mesh;
    Sky_3: THREE.Mesh;
    Sky_1: THREE.Mesh;
    Floor001: THREE.Mesh;
    Floor002: THREE.Mesh;
  };
  materials: {
    ["Color.001"]: THREE.MeshStandardMaterial;
    ["Glass.001"]: THREE.MeshStandardMaterial;
    ["Parking.001"]: THREE.MeshStandardMaterial;
    ["Fence.001"]: THREE.MeshStandardMaterial;
    ["Torre_logo.001"]: THREE.MeshStandardMaterial;
    ["Main_screen.001"]: THREE.MeshStandardMaterial;
    ["Metal.001"]: THREE.MeshStandardMaterial;
    ["Grass.001"]: THREE.MeshStandardMaterial;
    ["Floor_Herringbone.001"]: THREE.MeshStandardMaterial;
    Floor_Herringbone: THREE.MeshStandardMaterial;
    Brick: THREE.MeshStandardMaterial;
    ["Skyline.001"]: THREE.MeshStandardMaterial;
    Floor_Tiles: THREE.MeshStandardMaterial;
  };
};

type EscenaGLTFResult = GLTF & {
  nodes: {
    Main: THREE.Mesh;
  };
  materials: {
    ["Color.001"]: THREE.MeshStandardMaterial;
  };
};

export default function Model({ ...props }: JSX.IntrinsicElements["group"]) {
  const group = useRef<THREE.Group>();
  const { nodes, materials } = useLoader<GLTFResult>(
    GLTFLoader,
    "gltf/entorno/entorno.gltf",
  );
  const escena = useLoader<EscenaGLTFResult>(
    GLTFLoader,
    "gltf/logos/Escena.gltf",
  );
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        geometry={escena.nodes.Main.geometry}
        material={escena.materials["Color.001"]}
        position={[-13.877916, 2.906428, 81.78437]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Glass.geometry}
        material={materials["Glass.001"]}
        position={[-12.771535, 4.407491, 150.710754]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Parking.geometry}
        material={materials["Parking.001"]}
        position={[90.228661, -0.11221, -39.967239]}
        scale={[0.010536, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Rejas.geometry}
        material={materials["Fence.001"]}
        position={[15.951677, 0.484576, 31.780569]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Torre_logo.geometry}
        material={materials["Torre_logo.001"]}
        position={[44.747311, 10.753016, 74.643799]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Main_screen.geometry}
        material={materials["Main_screen.001"]}
        position={[-51.667088, 10.598541, 68.485214]}
        rotation={[0, -0.069813, -Math.PI / 2]}
        scale={[0.100985, 0.110332, 0.100985]}
      />
      <mesh
        geometry={nodes.Metal.geometry}
        material={materials["Metal.001"]}
        position={[-19.35848, 5.819624, 134.058762]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Grass.geometry}
        material={materials["Grass.001"]}
        position={[-3.505585, 0.320975, 67.536049]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Floor.geometry}
        material={materials["Floor_Herringbone.001"]}
        position={[-3.537802, 0.006605, 88.057037]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Herringbone.geometry}
        material={nodes.Herringbone.material}
        position={[-30.686436, 0, 62.379425]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Brick.geometry}
        material={materials.Brick}
        position={[-58.348099, 6.269471, 91.783203]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Sky_2.geometry}
        material={nodes.Sky_2.material}
        position={[3.159204, 24.327391, 16.167919]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Sky_3.geometry}
        material={nodes.Sky_3.material}
        position={[3.159286, 37.613792, 16.168032]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Sky_1.geometry}
        material={nodes.Sky_1.material}
        position={[3.159254, 7.03983, 16.167969]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Floor001.geometry}
        material={materials.Floor_Tiles}
        position={[-3.537802, 0.006605, 88.057037]}
        scale={[0.01, 0.01, 0.01]}
      />
      <mesh
        geometry={nodes.Floor002.geometry}
        material={nodes.Floor002.material}
        position={[-3.537802, 0.006605, 88.057037]}
        scale={[0.01, 0.01, 0.01]}
      />
    </group>
  );
}
